/** Visual surface scoping for the SailGP+ restyle.
 *
 * A surface is entered by every route that wants it and left on unmount. Two
 * sibling routes can be mounted at once during a transition, so the state is a
 * ref count rather than a boolean: the surface stays active until the last
 * holder leaves. Pure module (no React) so it is unit-testable under the
 * node-environment vitest config. */

export type Surface = "sgp";

export type SurfaceCounts = Record<Surface, number>;

export type SurfaceAction = { type: "enter" | "leave"; surface: Surface };

export const initialSurfaceCounts: SurfaceCounts = { sgp: 0 };

/** Ref-count reducer. A leave with no matching enter is a no-op: the count
 * never goes below 0, so a double-invoked cleanup cannot strand the surface. */
export function surfaceReducer(
  state: SurfaceCounts,
  action: SurfaceAction,
): SurfaceCounts {
  const current = state[action.surface] ?? 0;
  const next =
    action.type === "enter" ? current + 1 : Math.max(0, current - 1);
  if (next === current) return state;
  return { ...state, [action.surface]: next };
}

/** The surface to stamp, or null when nothing is held. */
export function activeSurface(state: SurfaceCounts): Surface | null {
  return state.sgp > 0 ? "sgp" : null;
}
